module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sidekick/free-user-flag.png"